import { a as r } from "../internals/array-buffer-view-core.js";
import { t } from "../internals/to-length.js";
import { t as e } from "../internals/to-absolute-index.js";
import { t as a } from "../internals/typed-array-species-constructor.js";
var s = r.aTypedArray;
(0, r.exportTypedArrayMethod)("subarray", function (r, o) {
  var n = s(this),
    i = n.length,
    f = e(r, i);
  return new (a(n))(n.buffer, n.byteOffset + f * n.BYTES_PER_ELEMENT, t((void 0 === o ? i : e(o, i)) - f));
});